import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { motion } from "framer-motion";
import { reportUserError } from "@/lib/report-error";
export default function Auth() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const navigate = useNavigate();
  const {
    toast
  } = useToast();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (isSignUp) {
        const {
          error
        } = await supabase.auth.signUp({
          email,
          password,
          options: {
            data: {
              full_name: fullName
            }
          }
        });
        if (error) throw error;
        toast({
          title: "Conta criada com sucesso!",
          description: "Verifique seu email para confirmar o cadastro."
        });
      } else {
        const {
          data: signInData,
          error
        } = await supabase.auth.signInWithPassword({
          email,
          password
        });
        if (error) throw error;

        // Verificar perfil para redirect condicional
        let redirectPath = "/dashboard";
        if (signInData?.user) {
          try {
            const { data: profileData } = await supabase
              .from("v_profiles_with_access_profile")
              .select("access_profile_slug")
              .eq("id", signInData.user.id)
              .single();
            if (profileData?.access_profile_slug?.includes("agencia")) {
              redirectPath = "/agencia/avaliacoes";
            }
          } catch {
            // Fallback para dashboard padrão
          }
        }
        navigate(redirectPath);
      }
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Erro na autenticação",
        description: reportUserError(error, { source: "auth" }).description
      });
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen flex flex-col items-center justify-center bg-linear-to-br from-background via-background to-secondary/10 p-4">
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <motion.img initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} src="/corisco-logo.png" alt="Corisco Logo" className="h-16 w-auto mb-4" />
          <h2 className="text-2xl font-bold tracking-tight text-foreground">
            {isSignUp ? "Criar nova conta" : "Bem-vindo de volta"}
          </h2>
          <p className="text-muted-foreground text-center">
            {isSignUp ? "Preencha os dados abaixo para começar" : "Entre com suas credenciais para acessar"}
          </p>
        </div>

        <Card className="border-2 shadow-lg bg-card">
          <CardHeader className="space-y-1">
            <div className="w-full h-1 bg-linear-to-r from-primary/80 via-primary/50 to-primary/20 rounded-full" />
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {isSignUp && <div className="space-y-2">
                  <Label htmlFor="fullName" className="text-foreground">Nome completo</Label>
                  <Input id="fullName" type="text" placeholder="Digite seu nome completo" value={fullName} onChange={e => setFullName(e.target.value)} required className="border-2 bg-background/50" />
                </div>}
              <div className="space-y-2">
                <Label htmlFor="email" className="text-foreground">Email</Label>
                <Input id="email" type="email" placeholder="Digite seu email" value={email} onChange={e => setEmail(e.target.value)} required className="border-2 bg-background/50" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password" className="text-foreground">Senha</Label>
                <Input id="password" type="password" placeholder="Digite sua senha" value={password} onChange={e => setPassword(e.target.value)} required className="border-2 bg-background/50" />
              </div>
              <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground" disabled={isLoading}>
                {isLoading ? "Carregando..." : isSignUp ? "Criar conta" : "Entrar"}
              </Button>
              
            </form>
          </CardContent>
        </Card>
      </motion.div>
    </div>;
}